module.exports = __webpack_public_path__ + "static/media/search staff by dprt.f306a055.svg";